<template>
	<div class="main" v-title data-title="零部件搜索列表">
		<iHeader :title="titleDec"></iHeader>
		<div class="flexRow justBetween barprebox">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item><router-link :to="{path:'/'}">首页</router-link></el-breadcrumb-item>
				<el-breadcrumb-item v-for="(item,index) in handLoc" :key="index" >
					<span @click="handbread(handLoc[index].id)">
						{{item.title}}</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item> 搜索'{{keyword}}'的相关结果</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="justBetween barprebox bgWhit mb20">
			<div class="mlr" style="text-align: left;">
			<!-- 	<div class="labelC">
					<span class="mr20 branT font14">相关搜索</span>
					<el-link type="success" class="xgsearch" :underline="false">直线轴承</el-link>
					<el-link type="success" class="xgsearch" :underline="false">弹簧</el-link>
					<el-link type="success" class="xgsearch" :underline="false">联轴器</el-link>
					<el-link type="success" class="xgsearch" :underline="false">铰链</el-link>
					<el-link type="success" class="xgsearch" :underline="false">螺丝</el-link>
				</div> -->
				<div class="labelC">
					<span class="mr20 branT">品牌</span>
					<div class="showDown">
						<el-radio-group v-model="brandstatus" v-for="(item,index) in ComList" :key="index" @change="handleSubmit(1,item.userid)" size="small">
							<el-radio-button :label="item.userid"   class="brand">{{item.company}}</el-radio-button>
						</el-radio-group>
					</div>
					<el-link type="success" class="xgsearch" :underline="false" v-if="ComList.length >8" @click="changeFoldState">{{brandFold?'更多+':'收起'}}</el-link>
				</div>
				<div class="labelC">
					<span class="mr20 branT">分类</span> 
						<div class="Cpanel">
							<el-radio-group v-model="catestatus" v-for="(item,index) in catelist" :key="index" size="small"  @change="handleSubmit(2,item.id)" >
								<el-radio-button :label="item.id" class="brand">{{item.title}}</el-radio-button>
							</el-radio-group>
						</div>
				</div>
				<div class="labelC">
					<span class="mr20 branT">发货地</span> 
						<div class="Cpanel">
							<el-radio-group v-model="addressstatus" v-for="(item,index) in addresslist" :key="index" size="small" @change="handleSubmit(3,item.id)">
								<el-radio-button :label="item.id" class="brand">{{item.name}}</el-radio-button>
							</el-radio-group>
						</div>
					
				</div>
				<!-- <div class="labelC">
					<span class="mr20 branT">CAD模型</span>
					<el-radio-group v-model="modestatus" v-for="(item,index) in catelist" :key="index" size="small">
						<el-radio-button :label="item.id" @click.native="handleSubmit(3,item.id)" class="brand">{{item.title}}</el-radio-button>
					</el-radio-group>
				</div>
				<div class="labelC">
					<span class="mr20 branT">发货地</span>
					<el-radio-group v-model="addressstatus" v-for="(item,index) in catelist" :key="index" size="small">
						<el-radio-button :label="item.id" @click.native="handleSubmit(4,item.id)" class="brand">{{item.title}}</el-radio-button>
					</el-radio-group>
				</div> -->
			</div>
		</div>
		<div class="justBetween barprebox bgWhit">
			<div style="text-align: left; padding: 0px 10px 10px 10px ;margin-top: 10px;">
				<div class="cateP">相关产品：<span class="color2 bold">{{total}}</span>件
					<el-pagination @current-change="handleCurrentChange" @size-change="handSizeChange":current-page.sync="page" :page-size.sync="pcount" :page-sizes="[10, 20, 30, 40]"
					 layout="prev, pager, next,sizes,total" :total='total' class="Spage">
					</el-pagination>
				</div>
				<div class="pdb30">
					<div class="demo-image" v-if="Ginfo.length!=0">
						<div class="block blockInfocate" v-for="(item,index) in Ginfo" @mousemove="addClassload($event)" @mouseout="removeClassload($event)"
						 @click="jumpurl(item.id)" :title="item.catid_name">
							<el-image style="width: 190px; height: 190px" :src="'https://images.mfcad.cn/'+item.thumb"
							 fit="cover" @mousemove="ImgaddClassload($event)" @mouseout="ImgremoveClassload($event)"></el-image>
							 <div class="demonstration font14 fl color3overtitle  mt10 ">{{ item.title }}</div>
							<div class="font14 flbold overtitle Stitle bold" style="width: 100%;">{{item.catname}}</div>
							<el-button class="btnL" type="primary" size="mini" icon="iconfont icon-yuedu">产品目录</el-button>
						</div>
					</div>
					<div class="demo-image" v-else-if="Ginfo.length==0">
						<p class="txc mt10">暂无数据</p>
					</div>
					<div class="block pdb10 " style="float: right">
						<el-pagination @current-change="handleCurrentChange" @size-change="handSizeChange":current-page.sync="page" :page-size.sync="pcount" :page-sizes="[10, 20, 30, 40]"
						layout="prev, pager, next,sizes,total" :total='total' class="Spage">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import iHeader from "@/components/indexheader"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter
		},
		// 品牌展开收起
		computed: {
		   showdetailList: {
		      get: function () {
		         if (this.brandFold) {
		             if (this.ComList.length < 8) {
		                return this.ComList
		             }
		             let newArr = []
		             for (var i = 0; i <8; i++) {
		                 let item = this.ComList[i]
		                 newArr.push(item)
		              }
		              return newArr
		           }
		           return this.ComList
		        },
		        set: function (val) {
		            this.showdetailList = val
		        }
		    }
		},
		data() {
			return {
				titleDec: "",
				handLoc: [],
				ComList: [],
				Ginfo: [],
				brandstatus:'',
				catestatus:'0',
				addressstatus:'0',
				modestatus:'',
				addressstatus:'',
				// 顶级id
				firstID: '',
				//共有多少产品
				total: 1,
				pcount: 10, //每页多少条
				page: 1, //当前页码数
				cateNum: 0,
				catelist: [],
				//
				catid: '',
				keyword: '',
				comnum: 0,
				catname: '',
				brandFold: true,
			    // 品牌
				brandlist:[],
				modepro:'目录分类',
				searchid:'',
				Pcatename:'',
				// 地址分类
				addresslist:[],
				handLoc: [],
			}
			
		},
		created() {
			this.catid = this.$route.query.cateid;
			this.keyword = this.$route.query.keyword;
			this.catname = this.$route.query.catname;
			this.catestatus=this.catid
			this.handClocation();
			// console.log(2)
			this.handcateSearch('',this.$route.query.cateid,this.brandstatus,this.keyword,this.catname);
		},
		methods: {
			handbread(catid) {
				let routeData = this.$router.resolve({
					path: "/list/catelist",
					query: {
						cateid: catid,
					}
				})
				window.open(routeData.href, '_self');
			},
			handClocation(){
				this.$postcn('partshome/getlisttab', {
					catid: this.catid, //分类顶级
				}, this).then((res) => {
					this.handLoc=res.data
				})
			},
			changeFoldState($event) {
				// $event.currentTarget.previousElementSibling.className = "showDown showH";
			    this.brandFold = !this.brandFold
			},
			handleSubmit(index,Idstatus) {
				if(index==1){
					this.brandstatus=Idstatus
				}else if(index==2){
					this.catestatus=Idstatus
				}else if(index==3){
					this.addressstatus=Idstatus
				}
				this.handcateSearch("cate",this.catestatus,this.brandstatus,this.keyword, this.catname)
			},
			//分页
			//点击第几页
			handleCurrentChange(val) {
				this.page = val;
				this.handcateSearch("cate",this.catestatus,this.brandstatus,this.keyword, this.catname)
			},
			handSizeChange(val){
				this.pcount=val;
				// console.log(this.pcount)
				this.handcateSearch("cate",this.catestatus,this.brandstatus,this.keyword, this.catname)
			},
			handcateSearch(type,catid,userid,keyword, catname) {
				this.keyword = keyword;
				this.catid = catid;
				this.catname = catname;
				// console.log(this.catestatus);return false;
				if(this.catestatus==""){
					this.searchid=this.catid
				}else{
					this.searchid=this.catestatus
				}
				let routeData = this.$router.resolve({
					path: "/list/searchlist",
					query: {
						cateid: this.searchid,
						keyword: this.keyword,
						catname: this.catname
					}
				})
				window.open(routeData.href, '_self');
				this.$postcn('partshome/productlist', {
					catid: this.searchid, //分类顶级
					userid:this.brandstatus,
					searchkeyword: this.keyword, //搜索值
					p: this.page, //第几页
					pcount: this.pcount, //一页显示多少条
					status: '99',
					addressp:this.addressstatus
				}, this).then((res) => {
					if (type != 'cate') {
						this.catelist = res.data.catidarr;
						this.cateNum = res.data.catidarr_count;
					}
					this.addresslist=res.data.addressp;
					this.Ginfo = res.data.data;
					this.total = res.data.count;
					this.ComList = res.data.enter;
					this.comnum = res.data.enter_count
					this.Pcatename=res.data.catename;
				})
			},
			jumpurl(id) {
				let routeData = this.$router.resolve({
					name: "content",
					query: {
						goodsid: id
					}
				})
				window.open(routeData.href, '_blank');
			},
			
			addClassload($event) {
				$event.currentTarget.className = "block blockInfocate active";
			},
			removeClassload($event) {
				$event.currentTarget.className = "block blockInfocate";
			},
			ImgaddClassload($event) {
				$event.currentTarget.className = "el-image__inner Wactive";
			},
			ImgremoveClassload($event) {
				$event.currentTarget.className = "el-image__inner";
			}
		}
	}
</script>

<style scoped>
	
	.icon-yuedu {
		margin-right: 5px;
		vertical-align: middle;
	}
	.showH{
		height: 120PX;
	}
    .showDown{
		display: inline-block;
	}
	.branT {
		width: 70px;
		text-align-last: justify;
		display: inline-block;
	}

	.el-breadcrumb {
		height: 62px;
		line-height: 62px !important;
		font-size: 14px;
	}

	.Stitle {
		height: 30px;
		line-height: 26px;
	}
	.Cdiv {
		width: 280px;
		height: 85px;
		border: 1px solid #CCCCCC;
		overflow: hidden;
		padding: 10PX;
		display: inline-block;
		margin-left: 10px;
	}

	.CimgDiv {
		width: 45px;
		height: 45px;
		display: inline-block;
		float: left;
	}

	.CiName {
		font-size: 16px;
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		width: 210px;
		/*需要配合宽度来使用*/

	}

	.saleD {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		width: 280px;
		text-align: left;
	}

	.inlinD {
		display: inline-block;
		float: left;
		padding-left: 20px;
		line-height: 20PX;
		margin-top: 6PX;
	}

	.Pdiv1 {
		width: 100%;
		display: block;
		height: 50px;
	}

	.ulH {
		height: 114px;
		overflow-y: scroll;
	}

	.CateL {
		text-align: left;
		border: 1px solid #ccc;
		margin-top: 10px;

	}

	.cateP {
		font-size: 14px;
		padding: 10px;
		margin: 0px;
		line-height: 25px;
		border-bottom: 1px solid #f4f4f4;
	}

	.labelC {
		padding: 10px 20PX;
		background: #FFFFFF;
	}

	.Spage {
		background: #fff;
		width: auto;
		border-radius: 2px;
		display: inline-block;
		position: absolute;
		right: 20px;
		margin-top: -3px;
	}

	.blockInfocate {
		padding: 10px 10px 20px 10px;
		text-align: center;
		display: inline-block;
		width: 245px;
		margin: 10px;
		box-sizing: border-box;
		vertical-align: top;
		background-color: #fFF;
		border: 1px solid #eaeaea;
	}

	.h25 {
		height: 25px;
	}

	.demonstration {
		width: 100%;
	}

	.active {
		border-color: #1f75cf;
		color: #1f75cf;
	}

	.Wactive {
		width: 190PX;
		cursor: pointer;
		transform: scale(1.5, 1.5)
	}

	.partstubiao_daochuCAD {
		font-size: 16px;
		margin-right: 5px;
	}
    .Cpanel{
		width:1100px;
		display: inline-block;
		vertical-align: middle;
	}
</style>
<style>
	
	.el-collapse-item__content {
		text-align: left;
	}
	.el-collapse-item__header {
		padding: 0px 10px;
	}
	.btnL.el-button--mini {
		text-align: center;
		line-height: 12px;
	}
	.xgsearch.el-link.el-link--success,.xgsearch.el-link.el-link--success:hover{
		color: #005dbe;
	}
	.btnL.el-button--primary {
		color: #d6d6d6;
		background-color: #ffffff;
		border-color: #d6d6d6;
	}
	
	.btnL.el-button--primary:hover {
		color: #FFF;
		background-color: #005dbe;
		border-color: #005dbe;
	}
	
	.el-pagination .el-select .el-input .el-input__inner {
		padding-right: 25px;
		border-radius: 3px;
		height: 25px !important;
		line-height: 25px !important;
		width: 100px !important;
	}
	.brand .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #005dbe;
		border-color: #005dbe;
	}
	
	.brand .el-radio-button__inner {
		border-left: none !important;
	}
	
	.brand .el-radio-button__inner {
		border: none;
	}
</style>



// WEBPACK FOOTER //
// src/pages/list/searchlist.vue